import React from 'react';
import Loader from '../../shared/components/Loader';

const SportLoader = () => <Loader className='empty-state' />;
export default SportLoader;
